var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10.0574C21.915 9.4724 20.97 9.4724 20.385 10.0574L13.5 16.9424C12.915 17.5274 12.915 18.4724 13.5 19.0574L20.385 25.9424C20.97 26.5274 21.915 26.5274 22.5 25.9424C23.085 25.3574 23.085 24.4124 22.5 23.8274L16.68 17.9924L22.5 12.1724C23.085 11.5874 23.07 10.6274 22.5 10.0574Z",
    fill: "#2D2322"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronLeft);
export default __webpack_public_path__ + "static/media/icon-chevron-left.d5374061ba06238198dfd4fc711ed9dd.svg";
export { ForwardRef as ReactComponent };